import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import SingleChoice from './SingleChoice'
import FullName from './FullName'
import ShortText from './ShortText'
import Address from './Address'
import Phone from './Phone'
import Number from './Number'
import Email from './Email'
import DropDown from './DropDown'
import MultiChoice from './MultiChoice'
import LongText from './LongText'

const MedicalAbstractSubmissionForm = () => {


    const presentationData = [
        'پوستر',
        'شفاهی',
        'بدون اولویت',
    ]


    const equipmentData = [
        'پروژکتور تکی',
        'پروژکتور دوتایی',
        'ال سی دی',
        'کامپیوتر',
    ]


    const abstractTopicsData = [
        {
            id: 1,
            label: 'اچ‌آی‌وی / ایدز',
            checked: false
        },
        {
            id: 2,
            label: 'مقاومت ضد میکروبی',
            checked: false
        },
        {
            id: 3,
            label: 'سل',
            checked: false
        },
        {
            id: 4,
            label: 'عوامل ضد میکروبی جدید و کشف دارو',
            checked: false
        },
        {
            id: 5,
            label: 'سپسیس و شوک سپتیک',
            checked: false
        },
        {
            id: 6,
            label: 'ذات‌الریه',
            checked: false
        },
        {
            id: 7,
            label: 'عفونت‌های نوپدید و بازپدید',
            checked: false
        },
        {
            id: 8,
            label: 'هپاتیت',
            checked: false
        },
        {
            id: 9,
            label: 'مالاریا',
            checked: false
        },
        {
            id: 10,
            label: 'آنفلوآنزا',
            checked: false
        },
        {
            id: 11,
            label: 'عفونت‌ها و بیماران دچار نقص ایمنی',
            checked: false
        },
        {
            id: 12,
            label: 'عفونت‌های بیمارستانی',
            checked: false
        },
        {
            id: 13,
            label: 'عفونت‌های جراحی',
            checked: false
        },
        {
            id: 14,
            label: 'عفونت‌های بیمارستانی',
            checked: false
        },
        {
            id: 15,
            label: 'ایمونوتراپی',
            checked: false
        },
    ]


    const prefixData = [
        {
            id: 1,
            label: "دکتر",
            checked: false
        },
        {
            id: 2,
            label: "پروفسور",
            checked: false
        },
        {
            id: 3,
            label: "آقای",
            checked: false
        },
        {
            id: 4,
            label: "خانم",
            checked: false
        },
    ]

    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ارسال خلاصه'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <SingleChoice header={'پیشوند'} options={prefixData}/>
                <FullName header={'نام و نام خانوادگی'} />
                <ShortText header={'دپارتمان'} />
                <ShortText header={'موسسه / سازمان'} />
                <Address header={'آدرس'} />
                <Phone header={'شماره تلفن'} />
                <Number header={'شماره فکس'} />
                <Email header={'آدرس ایمیل'} />
                <DropDown header={'نوع ارائه'} options={presentationData} />
                <DropDown header={'تجهیزات مورد نیاز'} options={equipmentData} />
                <MultiChoice header={'موضوعات خلاصه (لطفاً مناسب‌ترین را انتخاب کنید)'} options={abstractTopicsData}/>
                <ShortText header={'عنوان خلاصه'} />
                <ShortText header={'گوینده'} />
                <ShortText header={'نویسنده'} />
                <LongText header={'موسسه، دپارتمان، شهر و کشور'} />
                <LongText header={'اهداف'} />
                <LongText header={'طراحی مطالعه'} />
                <LongText header={'اهمیت مطالعه'} />
                <LongText header={'تنظیمات'} />
                <LongText header={'جمعیت مورد مطالعه'} />
                <LongText header={'روش‌شناسی'} />
                <LongText header={'نتایج'} />
                <LongText header={'نتیجه‌گیری'} />
            </Grid>
        </Grid>
    )
}

export default MedicalAbstractSubmissionForm
